import classNames from 'classnames';
import React from 'react';
// import { SpriteSvg, SpriteSvgType } from '../../../components/sprite-svg';
import { ISystemMenuItem } from '../../../model/system/menu';
import { MenuItem } from './menu-item';
import MenuDown from '../../../assets/svg/menu-down.svg';
import { CommonStatusStep, IMyFavoriteItem } from '../../../model/api-modules';

interface IProps {
  readonly menu: ISystemMenuItem;
  readonly myFavoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly selectedMenuID: string;
  readonly onClickItem: (key: number) => void;
  readonly addFavorites: (id: number, status: number) => void;
  readonly openMenu: string;
  readonly clickMenu: (name: string) => void;
}

export const MenuGroup = (props: IProps) => {
  // const [open, setOpen] = useState<boolean>(true);
  const onMenuExpand = () => {
    if (props.menu.name === props.openMenu) {
      props.clickMenu('');
    } else {
      props.clickMenu(props.menu.name);
    }
    // setOpen(!open);
  };

  const renderItems = (menus: ReadonlyArray<ISystemMenuItem>) => {
    return (
      <div className="group-body">
        <ul className="sidebar-nav">
          {menus.map((menu) => {
            if (menu.status !== CommonStatusStep.Resolve) {
              return null;
            }
            return (
              <MenuItem
                key={menu.id}
                menu={menu}
                myFavoriteList={props.myFavoriteList}
                selectedMenuID={props.selectedMenuID}
                isSubMenu
                onClickItem={props.onClickItem}
                addFavorites={props.addFavorites}
              />
            );
          })}
        </ul>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div className="group-head" onClick={onMenuExpand}>
        <div className="col-icon">
          <span className="dot">
            <i></i>
          </span>
        </div>
        <div className="col-title">{props.menu.name}</div>
        <div className="col-arrow">
          {/* <SpriteSvg type={SpriteSvgType.ChevronDown} /> */}
          <img src={MenuDown} />
        </div>
      </div>
    );
  };

  const className = classNames(
    'sidebar-nav-group',
    props.openMenu === props.menu.name ? 'open' : '',
    props.myFavoriteList ? 'notfavoriteList' : ''
  );
  return (
    <div className={className}>
      {renderHeader()}
      {props.menu.subMenus?.length ? renderItems(props.menu.subMenus) : null}
    </div>
  );
};
